/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';

import {colors} from "../styles/colors";
import {CircularProgress} from 'material-ui/Progress';
import Button from 'material-ui/Button';
import {LinearProgress} from "material-ui";
import moment from 'moment';
export default class PayoutTable extends React.PureComponent {

    convertCentToAmount(cents) {
        return Math.trunc(cents / 100);
    }

    getPayoutAmount(periodPosition){
        const total = this.props.total;
        const extraPayout1 = this.props.extraPayout1;
        const extraPayout2 = this.props.extraPayout2;
        const extraPayout3 = this.props.extraPayout3;
        const extraPayout4 = this.props.extraPayout4;
        if (periodPosition === 1) {
            return this.convertCentToAmount(total * periodPosition + extraPayout1);
        } else if (periodPosition === 2) {
            return this.convertCentToAmount(total * periodPosition + extraPayout2);
        } else if (periodPosition === 3) {
            return this.convertCentToAmount(total * periodPosition + extraPayout3);
        } else if (periodPosition === 4) {
            return this.convertCentToAmount(total * periodPosition + extraPayout4);
        } else {
            return this.convertCentToAmount(total * periodPosition + extraPayout4);
        }
    }


    getHighlighted(periodPosition){
        const period = this.props.period;
        if(periodPosition === 1 && period > 4){
            return 'highlighted';
        }else {
            if (periodPosition === period) {
                return 'highlighted';
            } else {
                return '';
            }
        }
    }

    render() {
        return (
            <div style={styles.wrapper}>
                <table className="payout-table" >
                    <tbody>
                    <tr>
                        <td className="header"><p>{this.props.leftCellHeader}</p></td>
                        <td className="header"><p>{this.props.rightCellHeader}</p></td>
                    </tr>
                    <tr>
                        <td className={`content ${this.getHighlighted(1)}`}><p>{this.props.workoutsPerOrder}</p></td>
                        <td className={`content ${this.getHighlighted(1)}`}><p>{this.getPayoutAmount(1)} €</p></td>
                    </tr>
                    <tr>
                        <td className={`content ${this.getHighlighted(2)}`}><p>{this.props.workoutsPerOrder * 2}</p></td>
                        <td className={`content ${this.getHighlighted(2)}`}><p>{this.getPayoutAmount(2)} €</p></td>
                    </tr>
                    <tr>
                        <td className={`content ${this.getHighlighted(3)}`}><p>{this.props.workoutsPerOrder * 3}</p></td>
                        <td className={`content ${this.getHighlighted(3)}`}><p>{this.getPayoutAmount(3)} €</p></td>
                    </tr>
                    <tr>
                        <td className={`content ${this.getHighlighted(4)}`}><p>{this.props.workoutsPerOrder * 4}</p></td>
                        <td className={`content ${this.getHighlighted(4)}`}><p>{this.getPayoutAmount(4)} €</p></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

const styles = ({
    wrapper: {
        position: 'relative',
    },
});




// WEBPACK FOOTER //
// ./src/components/PayoutTable.js